module.exports = __webpack_public_path__ + "img/icon_aside_word4.e00f12ed.svg";